import { useRef, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { registerToastShow, registerToastClear } from './toastService';

export const ToastManager = () => {
  const toasts = {
    errorToast: useRef<Toast>(null),
    warningToast: useRef<Toast>(null),
    copyToast: useRef<Toast>(null),
    connectionErrorToast: useRef<Toast>(null),
    micAccessDeniedToast: useRef<Toast>(null),
    reconnectingToast: useRef<Toast>(null),
    reconnectingSuccessToast: useRef<Toast>(null)
  };

  useEffect(() => {
    registerToastShow((name: string, severity, summary, detail, sticky) => {
      toasts[name as keyof typeof toasts].current?.show({
        severity,
        summary,
        detail,
        sticky,
        life: 3000
      });
    });
    registerToastClear((name: string) => {
      toasts[name as keyof typeof toasts].current?.clear();
    });
  }, []);

  return (
    <>
      <Toast className="custom-toast" ref={toasts.errorToast} position="top-center" />
      <Toast className="custom-toast" ref={toasts.warningToast} position="top-center" />
      <Toast className="custom-toast" ref={toasts.copyToast} position="top-center" />
      <Toast className="custom-toast" ref={toasts.connectionErrorToast} position="top-center" />
      <Toast className="custom-toast" ref={toasts.micAccessDeniedToast} position="top-center" />
      <Toast className="custom-toast" ref={toasts.reconnectingToast} position="top-center" />
      <Toast className="custom-toast" ref={toasts.reconnectingSuccessToast} position="top-center" />
    </>
  );
};
